import { AxiosPromise } from 'axios';
import i18next from 'i18next';
import request from '../utils/request';
import {
  AddOrgInfo,
  OrgInfoResDto,
  UpdateOrgInfo,
} from 'src/pages/Administrator/utils/types';
import { MenuOption } from '@Types/index';

function apiGetOrgs(): AxiosPromise<{
  details: {
    companyGuid: string;
    orgName: string;
    isDefault: boolean;
  }[];
  isManagedAll: boolean;
}> {
  const req = request({
    url: `company/orgs`,
    method: 'get',
    headers: { 'x-org-id': 'all' },
  });
  return req;
}

async function getOrgs(): Promise<MenuOption[]> {
  const data = (await apiGetOrgs()).data;
  const orgs: MenuOption[] = [];
  if (data.isManagedAll && data.details.length > 1) {
    orgs.push({
      key: 'all',
      value: i18next.t('common.label.allOrganizations'),
      isDefault: false,
    });
  }
  data.details.forEach((org) => {
    orgs.push({
      key: org.companyGuid,
      value: org.orgName,
      isDefault: org.isDefault,
    });
  });
  return orgs;
}

function getOrgsInfo(): AxiosPromise<OrgInfoResDto[]> {
  const req = request({
    url: `orgs`,
    method: 'get',
    headers: { 'x-org-id': 'all' },
  });
  return req;
}

function addOrg(orgInfo: AddOrgInfo): AxiosPromise<any> {
  const req = request({
    url: `orgs`,
    method: 'post',
    headers: { 'x-org-id': 'all' },
    data: orgInfo,
  });
  return req;
}

function updateOrg(orgInfo: UpdateOrgInfo): AxiosPromise<any> {
  const req = request({
    url: `orgs`,
    method: 'put',
    headers: { 'x-org-id': orgInfo.orgId },
    data: {
      orgName: orgInfo.orgName,
      orgDescription: orgInfo.orgDescription,
    },
  });
  return req;
}

function removeOrg(orgId: string): AxiosPromise<any> {
  return request({
    url: `orgs`,
    method: 'delete',
    headers: { 'x-org-id': orgId },
  });
}

export default {
  getOrgsInfo,
  addOrg,
  updateOrg,
  removeOrg,
  getOrgs,
};
